document.addEventListener('click', function(e){
  const toggle = e.target.closest('[data-mobile-toggle]');
  if(toggle){
    const nav = document.querySelector('[data-mobile-nav]');
    if(nav) nav.classList.toggle('is-open');
  }
});

document.addEventListener('change', function(e){
  const select = e.target.closest('[data-variant-select]');
  if(!select) return;

  const form = select.closest('[data-product-form]');
  const productInfo = select.closest('.product-info');
  const selected = select.options[select.selectedIndex];

  if(productInfo && selected && selected.dataset.price){
    const priceEl = productInfo.querySelector('.price');
    if(priceEl) priceEl.textContent = selected.dataset.price;
  }

  if(form && selected){
    const button = form.querySelector('[data-add-to-cart-button]');
    const available = selected.dataset.available === 'true';
    if(button){
      button.disabled = !available;
      button.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  }
});

// Phoenix Appeal product gallery: thumbnails swap the main image, main image opens large lightbox.
document.addEventListener('click', function(e){
  const thumb = e.target.closest('[data-gallery-thumb]');
  if(thumb){
    const gallery = thumb.closest('[data-product-gallery]');
    if(!gallery) return;

    const mainImage = gallery.querySelector('[data-gallery-main-image]');
    const lightboxImage = gallery.querySelector('[data-gallery-lightbox-image]');
    const mainSrc = thumb.dataset.mainSrc;
    const fullSrc = thumb.dataset.fullSrc || mainSrc;
    const altText = thumb.dataset.alt || '';

    if(mainImage && mainSrc){
      mainImage.src = mainSrc;
      mainImage.dataset.fullSrc = fullSrc;
      mainImage.alt = altText;
    }

    if(lightboxImage && fullSrc){
      lightboxImage.src = fullSrc;
      lightboxImage.alt = altText;
    }

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(button){
      button.classList.toggle('is-active', button === thumb);
    });
  }

  const openButton = e.target.closest('[data-gallery-open]');
  if(openButton){
    const gallery = openButton.closest('[data-product-gallery]');
    const lightbox = gallery && gallery.querySelector('[data-gallery-lightbox]');
    const mainImage = gallery && gallery.querySelector('[data-gallery-main-image]');
    const lightboxImage = gallery && gallery.querySelector('[data-gallery-lightbox-image]');

    if(lightbox && mainImage && lightboxImage){
      lightboxImage.src = mainImage.dataset.fullSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
  }

  const closeButton = e.target.closest('[data-gallery-close]');
  if(closeButton){
    const lightbox = closeButton.closest('[data-gallery-lightbox]');
    if(lightbox){
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
  }
});

document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  document.querySelectorAll('[data-gallery-lightbox].is-open').forEach(function(lightbox){
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
  });
  document.documentElement.style.overflow = '';
});
